"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nucleus_1 = require("@lifesize/nucleus");
const constants_1 = require("../constants");
const redux_1 = require("../utils/redux");
const get_1 = __importDefault(require("lodash/get"));
const { GALAXY_ACTION_END } = nucleus_1.nucleusConstants;
/** @module state/nucleus/app */
/**
 * @constant {Object}
 * @description Initial state
 * @default
 */
exports.initialState = {
    isInCallPipVisible: true,
    isPipPreviewVisible: false,
    isPresentationPromptVisible: false,
    volume: 0.5,
    isLegacyServiceDegraded: false,
    sipIncomingCall: null,
    sipActiveCall: null,
    inCallLayout: '',
    meetingStartPromptVisible: false,
    raiseHandErrors: [],
    selectedParticipant: null
};
/**
 * Stores 'app' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: bool
 * @example
 * store
 * +-- nucleus
 *     +-- app
 *       +-- isBackgrounded: false
 *       +-- sipIncomingCall
 *          +-- { id: '123', canAnswer: true, canAdd: false, canEndAndAnswer: false, dialString: '123@sip.com', displayString: 'Bob' }
 *       +-- sipActiveCall
 *          +-- { id: '123', state: 'connectected', dialString: '123@sip.com', displayString: 'Bob', startTime: int, endTime: int, .. }
 */
exports.default = redux_1.createReducer(exports.initialState, {
    [constants_1.app.actions.togglePresentationPrompt]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isPresentationPromptVisible: get_1.default(action, 'payload') === null ? !state.isPresentationPromptVisible : action.payload });
    },
    [constants_1.app.actions.toggleInCallPip]: (state, action) => {
        // If a payload is present, then assign the new value to match the payload, otherwise toggle the pip
        return Object.assign(Object.assign({}, state), { isInCallPipVisible: get_1.default(action, 'payload') === null ? !state.isInCallPipVisible : action.payload });
    },
    [constants_1.app.actions.togglePipPreview]: (state, action) => {
        // If a payload is present, then assign the new value to match the payload, otherwise toggle the pip preview
        return Object.assign(Object.assign({}, state), { isPipPreviewVisible: get_1.default(action, 'payload') === null ? !state.isPipPreviewVisible : action.payload });
    },
    [constants_1.app.actions.changeVolumeInCall]: (state, action) => {
        return Object.assign(Object.assign({}, state), { volume: get_1.default(action, 'payload') });
    },
    [constants_1.app.actions.setIsLegacyServiceDegraded]: (state, action) => (Object.assign(Object.assign({}, state), { isLegacyServiceDegraded: get_1.default(action, 'payload') })),
    [constants_1.app.actions.setSipIncomingCall]: (state, action) => (Object.assign(Object.assign({}, state), { sipIncomingCall: get_1.default(action, 'payload') })),
    [constants_1.app.actions.setSipActiveCall]: (state, action) => (Object.assign(Object.assign({}, state), { sipActiveCall: get_1.default(action, 'payload') })),
    [constants_1.app.actions.selectCallLayout]: (state, action) => (Object.assign(Object.assign({}, state), { inCallLayout: get_1.default(action, 'payload') })),
    [constants_1.app.actions.showMeetingStartPrompt]: (state, action) => (Object.assign(Object.assign({}, state), { meetingStartPromptVisible: get_1.default(action, 'payload.meetingStartPromptVisible') })),
    [constants_1.app.actions.setRaiseHandErrors]: (state, action) => {
        const error = get_1.default(action, 'payload');
        const raiseHandErrors = error ? state.raiseHandErrors.concat(error) : state.raiseHandErrors;
        return Object.assign(Object.assign({}, state), { raiseHandErrors });
    },
    [constants_1.app.actions.clearRaiseHandErrors]: state => (Object.assign(Object.assign({}, state), { raiseHandErrors: [] })),
    // Note: Stores the updated selected participant object with selected states, so it can be sent back to the RCA.
    // Also clears the selected participant when call ends.
    [constants_1.app.actions.selectParticipant]: (state, action) => (Object.assign(Object.assign({}, state), { selectedParticipant: get_1.default(action, 'payload') })),
    [GALAXY_ACTION_END]: state => (Object.assign(Object.assign({}, state), { selectedParticipant: null }))
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/reducers/display.js
// module id = 602
// module chunks = 0